import { useEffect, useLayoutEffect } from 'react'
import { savedChanges } from './storage'

export function useTrackChanges<T>(
  key: string,
  initialValue: T,
  value: T,
  setValue: (value: T) => void,
) {
  useLayoutEffect(() => {
    if (value === null) {
      setValue(initialValue)
    }
  }, [initialValue, value, setValue])

  useEffect(() => {
    let changes = savedChanges.get()

    if (!Array.isArray(changes)) {
      savedChanges.set([])
      changes = savedChanges.get() as string[]
    }

    if (Array.isArray(value)) {
      if (!Array.isArray(initialValue) || !arraysEqual(initialValue, value)) {
        if (!changes.includes(key)) savedChanges.set([...changes, key])
      } else if (changes.includes(key)) {
        savedChanges.set([...changes.filter((item) => item !== key)])
      }
    } else if (value === initialValue) {
      if (changes.includes(key)) {
        savedChanges.set([...changes.filter((item) => item !== key)])
      }
    } else if (!changes.includes(key)) {
      savedChanges.set([...changes, key])
    }
  }, [value, initialValue, key])
}

function arraysEqual(a: string[], b: string[]) {
  if (a.length !== b.length) return false
  for (var i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) return false
  }
  return true
}
